import React from 'react'

import { StyledLoadingDots as S } from './LoadingDots.styles'

export const LoadingDots: React.FC = () => <S.Dots />
